export default {
  LAND_ON: "land_on",
  SFX_IDENTIFIER_ERROR: "sfx_identifier_error",
  SFX_DOWNLOAD_BUTTON_CLICKED: "sfx_download_button_clicked",
};
